import {Entity} from '@s-ui/domain'

export default class PurchaseEntity extends Entity {
  /**
   * @param {Object} data
   * @param {Object} data.order
   * @param {String} data.order.productType
   * @param {Object} data.payment
   * @param {Object} data.payment.action
   * @param {String} data.payment.action.paymentMethodtype
   * @param {String} data.payment.action.token
   * @param {String} data.payment.action.type
   * @param {String} data.payment.status
   * */
}
